import './wdyr.ts'
import React from 'react'
import * as ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import TagManager from 'react-gtm-module'
import { setupListeners } from '@reduxjs/toolkit/query'

import { store } from '@homeviews/store' // Redux Store
import App from './app/app'

const tagManagerArgs = {
  gtmId: process.env.NX_GTM_ID || '',
}

if (tagManagerArgs.gtmId) {
  TagManager.initialize(tagManagerArgs)
}

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch)

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root'),
)
